class LiveRegionElement extends HTMLElement {
  constructor() {
    super();
    if (!this.shadowRoot) {
      const template2 = getTemplate();
      const shadowRoot = this.attachShadow({
        mode: "open"
      });
      shadowRoot.appendChild(template2.content.cloneNode(true));
    }
  }
  /**
   * Announce a message using a live region with a corresponding politeness
   * level.
   *
   * Note: a politeness level of `assertive` should only be used for
   * time-sensistive or critical notifications that absolutely require the
   * user's immediate attention
   *
   * @see https://www.w3.org/TR/wai-aria/#aria-live
   * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions
   */
  announce(message) {
    var _this$shadowRoot;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      politeness = "polite"
    } = options;
    const container = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.getElementById(politeness);
    if (!container) {
      throw new Error("Unable to find container for message");
    }
    if (container.textContent === message) {
      container.textContent = "".concat(message, "\xA0");
    } else {
      container.textContent = message;
    }
  }
  /**
   * Announce a message using the text content of an element with a
   * corresponding politeness level
   */
  announceFromElement(element, options) {
    const textContent = getTextContent(element);
    if (textContent !== "") {
      this.announce(textContent, options);
    }
  }
  getMessage() {
    var _this$shadowRoot2;
    let politeness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "polite";
    const container = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.getElementById(politeness);
    if (!container) {
      throw new Error("Unable to find container for message");
    }
    return container.textContent;
  }
}
function getTextContent(element) {
  let value = "";
  if (element.hasAttribute("aria-label")) {
    value = element.getAttribute("aria-label");
  } else if (element.innerText) {
    value = element.innerText;
  } else if (element.textContent) {
    value = element.textContent;
  }
  return value ? value.trim() : "";
}
let template = null;
const templateContent = "\n<style>\n:host {\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n</style>\n<div id=\"polite\" aria-live=\"polite\" aria-atomic=\"true\"></div>\n<div id=\"assertive\" aria-live=\"assertive\" aria-atomic=\"true\"></div>\n";
function getTemplate() {
  if (template) {
    return template;
  }
  template = document.createElement("template");
  template.innerHTML = templateContent;
  return template;
}
if (!customElements.get("live-region")) {
  customElements.define("live-region", LiveRegionElement);
}
function announce(message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const liveRegion2 = findOrCreateLiveRegion(options.from, options.appendTo);
  return liveRegion2.announce(message, options);
}
function announceFromElement(element) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const liveRegion2 = findOrCreateLiveRegion(options.from, options.appendTo);
  return liveRegion2.announceFromElement(element, options);
}
let liveRegion = null;
function findOrCreateLiveRegion(from, appendTo) {
  if (liveRegion !== null && liveRegion.isConnected) {
    return liveRegion;
  }
  liveRegion = from ? getClosestLiveRegion(from) : null;
  if (liveRegion !== null) {
    return liveRegion;
  }
  liveRegion = document.querySelector("live-region");
  if (liveRegion !== null) {
    return liveRegion;
  }
  liveRegion = document.createElement("live-region");
  if (appendTo) {
    appendTo.appendChild(liveRegion);
  } else {
    document.body.appendChild(liveRegion);
  }
  return liveRegion;
}
function getClosestLiveRegion(from) {
  let current = from;
  while (current = current.parentElement) {
    for (const child of current.childNodes) {
      if (child instanceof LiveRegionElement) {
        return child;
      }
    }
  }
  return null;
}
export { LiveRegionElement, announce, announceFromElement, templateContent };